var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 18,
    viewBox: "0 0 25 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8108 18C10.4279 18 10.107 17.8652 9.84797 17.5957C9.58896 17.3262 9.45946 16.9922 9.45946 16.5938C9.45946 16.1953 9.58896 15.8672 9.84797 15.6094C10.107 15.3516 10.4279 15.2227 10.8108 15.2227H14.1892C14.5721 15.2227 14.893 15.3574 15.152 15.627C15.411 15.8965 15.5405 16.2188 15.5405 16.5938C15.5405 16.9922 15.411 17.3262 15.152 17.5957C14.893 17.8652 14.5721 18 14.1892 18H10.8108ZM1.35135 2.77734C0.968468 2.77734 0.647522 2.64258 0.388513 2.37305C0.129504 2.10352 0 1.78125 0 1.40625C0 1.00781 0.129504 0.673828 0.388513 0.404297C0.647522 0.134766 0.968468 0 1.35135 0H23.6486C24.0315 0 24.3525 0.134766 24.6115 0.404297C24.8705 0.673828 25 1.00781 25 1.40625C25 1.80469 24.8705 2.13281 24.6115 2.39063C24.3525 2.64844 24.0315 2.77734 23.6486 2.77734H1.35135ZM5.40541 10.4063C5.02252 10.4063 4.70158 10.2715 4.44257 10.002C4.18356 9.73242 4.05405 9.39844 4.05405 9C4.05405 8.60156 4.18356 8.26758 4.44257 7.99805C4.70158 7.72852 5.02252 7.59375 5.40541 7.59375H19.5946C19.9775 7.59375 20.2984 7.72852 20.5574 7.99805C20.8164 8.26758 20.9459 8.60156 20.9459 9C20.9459 9.39844 20.8164 9.73242 20.5574 10.002C20.2984 10.2715 19.9775 10.4063 19.5946 10.4063H5.40541Z",
    fill: "#1773BC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIcon);
export default __webpack_public_path__ + "static/media/filter-icon.d39fea76b8abd31c08e57f94c0f7b3c7.svg";
export { ForwardRef as ReactComponent };